module.exports = __webpack_public_path__ + "img/cover-kurator.d4538778.jpg";